import { Interval } from '../types';

export const SET_INTERVAL = 'SET_INTERVAL';
export const SET_SELECTED_INTERVAL = 'SET_SELECTED_INTERVAL';
export const RESET_GRAPH_FILTERS = 'RESET_GRAPH_FILTERS';

export const setInterval = (interval: Interval) => {
  sessionStorage.setItem('chartFilterStartDate', interval.startDate);
  sessionStorage.setItem('chartFilterEndDate', interval.endDate);
  return {
    type: SET_INTERVAL,
    payload: interval,
  };
};

export const setSelectedInterval = (interval: string | null) => {
  if (interval) {
    sessionStorage.setItem('chartFilterInterval', interval);
  } else {
    sessionStorage.removeItem('chartFilterInterval');
  }
  return {
    type: SET_SELECTED_INTERVAL,
    payload: interval,
  };
};

export const resetGraphFilters = () => {
  sessionStorage.removeItem('chartFilterStartDate');
  sessionStorage.removeItem('chartFilterEndDate');
  sessionStorage.removeItem('chartFilterInterval');

  return {
    type: RESET_GRAPH_FILTERS,
  };
};
